import { Component, OnInit } from '@angular/core';
import { EnvService } from 'src/app/services/env.service';

@Component({
  selector: 'app-acercade',
  templateUrl: './acercade.component.html',
  styleUrls: ['./acercade.component.scss'],
})
export class AcercadeComponent implements OnInit {
  version_front = this.env.version_front;
  version_back = this.env.version_front; //corregir esto luego que no se porque no toma el del back
  web = 'https://www.analytikogroup.com/';
  email = 'soporte@analytikogroup.com';
  constructor(private env: EnvService) {}

  ngOnInit(): void {}
}
